import styled from 'styled-components';
import { useIntl } from 'react-intl';

import globalMessages from 'src/messages';
import { phoneLink } from 'src/utils/intlHelper';

import { getScreenBreaks } from 'src/utils/htmlHelper';

const Contact = () => {
    const intl = useIntl();

    return (
        <ContactWrapper>
            <ContactItem>
                <ContactItemHeader>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.callFromAustralia,
                        )}
                    </span>
                </ContactItemHeader>
                <ColoredTrialMessage>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.secondaryPhone,
                            {
                                a: phoneLink,
                            },
                        )}
                    </span>
                </ColoredTrialMessage>
            </ContactItem>
            <ContactItem>
                <ContactItemHeader>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.callFromNewZealand,
                        )}
                    </span>
                </ContactItemHeader>
                <ColoredTrialMessage>
                    <span>
                        {intl.formatMessage(
                            globalMessages.phones.primaryPhone,
                            {
                                a: phoneLink,
                            },
                        )}
                    </span>
                </ColoredTrialMessage>
            </ContactItem>
        </ContactWrapper>
    );
};

export default Contact;

export const ContactItem = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 16rem;
    white-space: break-spaces;
    font-size: 1rem;
`;

export const ContactWrapper = styled.div`
    margin-top: 4rem;
    display: flex;
    font-size: 1.1rem;
    justify-content: center;
    align-items: stretch;
    gap: 10rem;

    @media (max-width: ${(props) => getScreenBreaks(props).screenSMax}) {
        flex-direction: column;
        align-items: center;
        gap: 2rem;
    }
`;

export const ColoredTrialMessage = styled.div<{ isBold?: boolean }>`
    a {
        color: ${({ theme: { colors } }) => colors.white};
    }
    text-wrap: nowrap;
    font-size: 1.5rem;
    font-weight: bold;
`;

export const ContactItemHeader = styled.div`
    min-height: 2rem;
    text-align: center;
    margin-bottom: 0.5rem;

    span {
        font-size: 1.4rem;
        color: ${({ theme: { colors } }) => colors.white};
    }
`;
